import { render, staticRenderFns } from "./fileTab.vue?vue&type=template&id=61351142&scoped=true"
import script from "./fileTab.vue?vue&type=script&lang=js"
export * from "./fileTab.vue?vue&type=script&lang=js"
import style0 from "./fileTab.vue?vue&type=style&index=0&id=61351142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61351142",
  null
  
)

export default component.exports